import { useEffect, useState } from "react";
import "./WorkFlowRequestList.scss";
import { SAMPLE_LTR_DATA } from "./WorkFlowRequestList.data";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import { formatDate, formatDateTime } from "../../utils/Helper";

interface LogisticsTrialRequest {
  id: number;
  uuid: string;
  request_name: string;
  workflow_name: string;
  requestor_name: string;
  created_at: string;
}

const WorkFlowRequestList = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("active");
  const [ltrList, setLtrList] = useState<LogisticsTrialRequest[]>([]);

  useEffect(() => {
    getLtrRequestList();
  }, []);

  const getLtrRequestList = async () => {
    try {
      const { data } = await ApiService().client.get(URLS.WORKFLOW.REQUESTS);
      setLtrList(data.data);
    } catch (error) {
      console.error("Error fetching LTR List", error);
    }
  };
  return (
    <div className="workflow-list-page  full-width flex-column gap-16">
      <div className="list-upper-container-bar xetgo-font-tag flex-row align-items-center justify-content-space-between px-16 py-12">
        <p style={{ color: "#AA5200" }} className="xetgo-font-tag bold">
          Requests
        </p>
      </div>
      <div className="breadcrumbs-btns-middle-container flex-row align-items-center justify-content-space-between p-16">
        <div className="breadcrumbs-left-container xetgo-font-tag flex-row align-items-center p-2">
          <p
            onClick={() => setStatus("active")}
            className={`status flex-row align-items-center justify-content-center px-4 py-6 cursor-pointer ${
              status === "active" && "active-current-status"
            } `}
          >
            Active
          </p>
          <p
            onClick={() => setStatus("ongoing")}
            className={`status flex-row align-items-center justify-content-center px-4 py-6 cursor-pointer ${
              status === "ongoing" && "active-current-status"
            } `}
          >
            Ongoing
          </p>
          <p
            onClick={() => setStatus("resolved")}
            className={`status flex-row align-items-center justify-content-center px-4 py-6 cursor-pointer ${
              status === "resolved" && "active-current-status"
            } `}
          >
            Resolved
          </p>
        </div>

        <div
          onClick={() => navigate("/requests/create")}
          className="request-btn cursor-pointer px-18 py-6 flex-row align-items-center justify-content-center xetgo-font-tag"
        >
          + Request
        </div>
      </div>
      <div className="workflow-list-lower-main-container p-16">
        {ltrList.length > 0 && (
          <div className="list-table-main-container">
            <div className="heading-container-list ltr-list-grid xetgo-font-tag">
              <p className="right-border-ltr-container flex-row align-items-center justify-content-center p-12">
                #
              </p>
              <p className="right-border-ltr-container flex-row align-items-center justify-content-center p-12">
                Trial Request
              </p>
              <p className="right-border-ltr-container flex-row align-items-center justify-content-center p-12">
                Name
              </p>
              <p className="right-border-ltr-container flex-row align-items-center justify-content-center p-12">
                Workflow
              </p>
              <p className="right-border-ltr-container flex-row align-items-center justify-content-center p-12">
                Requested by
              </p>
              <p className="right-border-ltr-container flex-row align-items-center justify-content-center p-12">
                Stages Completed
              </p>
              <p className="flex-row align-items-center justify-content-center gap-8 p-12">
                Requested Date
                <img
                  height={16}
                  width={16}
                  src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240227122733-list-filter.svg"
                  alt="filter-icon"
                />
              </p>
            </div>
            <div className="all-lists-container">
              {ltrList.length > 0 &&
                ltrList.map((ltrData, index) => (
                  <div
                    onClick={() => navigate(`/request/${ltrData.id}`)}
                    key={index}
                    className={`ltr-list-container cursor-pointer ${
                      index % 2 == 0 && "ltr-odd-container"
                    } ${
                      SAMPLE_LTR_DATA.length - 1 != index &&
                      "bottom-border-ltr-container"
                    } ltr-list-grid xetgo-font-tag`}
                  >
                    <p className="flex-row align-items-center right-border-ltr-container justify-content-center p-12">
                      {index + 1}
                    </p>
                    <p className="ltr-request bold flex-row right-border-ltr-container align-items-center justify-content-center p-12">
                      {ltrData.uuid}
                    </p>
                    <p className="flex-row right-border-ltr-container align-items-center justify-content-center p-12">
                      {ltrData.request_name}
                    </p>
                    <p className="flex-row right-border-ltr-container align-items-center justify-content-center p-12">
                      {ltrData.workflow_name}
                    </p>
                    <p className="flex-row right-border-ltr-container align-items-center justify-content-center p-12">
                      {ltrData.requestor_name}
                    </p>
                    <p className="flex-row right-border-ltr-container align-items-center justify-content-center p-12">
                      {"ltrData.stages_completed"}
                    </p>
                    <p className="flex-row  align-items-center justify-content-center p-12">
                      {formatDate(ltrData.created_at)}
                    </p>
                  </div>
                ))}
            </div>
          </div>
        )}
        {SAMPLE_LTR_DATA.length === 0 && (
          <div className="empty-state-main-container flex-column gap-48 full-height full-width align-items-center justify-content-center">
            <img
              height={243}
              width={235}
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250304110621-Group.svg"
              alt="empty-icon"
            />
            <div className="text-containers flex-column gap-12 full-width ">
              <p style={{ color: "#3333336B" }}>
                {" "}
                Your List is empty, No Fields Added Yet!
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkFlowRequestList;
